import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sounds, startAmbient, stopAmbient, setMasterVolume } from '../utils/audioManager';

const useAudioStore = create(
  persist(
    (set, get) => ({
      soundEnabled: true,
      musicEnabled: false,
      volume: 0.5,

      toggleSound: () => {
        const next = !get().soundEnabled;
        set({ soundEnabled: next });
      },

      toggleMusic: () => {
        const next = !get().musicEnabled;
        set({ musicEnabled: next });
        if (next) {
          startAmbient();
        } else {
          stopAmbient();
        }
      },

      setVolume: (val) => {
        set({ volume: val });
        setMasterVolume(val);
      },

      /** Play a named sound effect if sound is enabled */
      play: (name) => {
        if (!get().soundEnabled) return;
        const fn = sounds[name];
        if (fn) fn();
      },

      /** Restore ambient state on rehydrate */
      restoreAmbient: () => {
        if (get().musicEnabled) {
          startAmbient();
        }
        setMasterVolume(get().volume);
      },
    }),
    {
      name: 'hst-audio-prefs',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        soundEnabled: state.soundEnabled,
        musicEnabled: state.musicEnabled,
        volume: state.volume,
      }),
    }
  )
);

export default useAudioStore;
